// src/components/MobileStickyRegisterBar.jsx
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const MobileStickyRegisterBar = () => {
  // TODO: Replace "#" with your actual WhatsApp group link
  const whatsAppLink = "#";

  return (
   <div className="d-block d-md-none fixed-bottom bg-white border-top shadow-sm" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <div className="container py-2">
        <div className="row align-items-center justify-content-end">
          {/* Button */}
          <div className="col-12 text-center">
            <a 
             href='https://chat.whatsapp.com/KAm7twNLkkH6hwBKK4pRcg?mode=wwt'
              className="btn  btn-success w-100 text-decoration-none fw-bold text-white" // Changed to btn-success for WhatsApp
             
            >
              Join WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileStickyRegisterBar;
